module.exports = __webpack_public_path__ + "img/popup_reward_metro.0df6b67e.png";